import { runtime } from '../data/runtime';

export const whatsappLink = (text = '') =>
  `https://wa.me/${runtime.BUSINESS.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ''}`;

export const track = (event, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', event, params);
  }
};

// Opens WhatsApp with the message. Returns the link so callers can show a fallback.
export const sendToWhatsApp = (text, event, params) => {
  const url = whatsappLink(text);
  if (event) track(event, params);
  window.open(url, '_blank', 'noopener,noreferrer');
  return url;
};

export const formatMessage = (title, fields) =>
  [title, '', ...fields.filter(([, v]) => v).map(([k, v]) => `${k}: ${v}`)].join('\n');

const UAE_PHONE = /^(?:\+?971|00971|0)?5\d{8}$/;
export const isValidUaeMobile = (value) => UAE_PHONE.test(value.replace(/[\s-]/g, ''));
export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
